import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GoalCreateFormMode } from '@app/models/goals/goal-create-form-mode.model';
import { GoalKeyResultMeasureUnitPlacement } from '@app/models/goals/goal-key-result-measure-unit-placement.model';
import { GoalKeyResultType } from '@app/models/goals/goal-key-result-type.model';
import { CompanyFeatures } from '@app/models/company-features.model';
import { Goal } from 'app/models/goals/goal.model';
import { Globals } from 'app/shared/globals/globals';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IMyDate } from '@nodro7/angular-mydatepicker';

@Component({
  selector: 'app-goals-create-key-result',
  templateUrl: './goals-create-key-result.component.html',
  styleUrls: ['./goals-create-key-result.component.scss']
})
export class GoalsCreateKeyResultComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe$: Subject<void> = new Subject<void>();

  readonly eGoalKeyResultType = GoalKeyResultType;
  readonly eGoalKeyResultMeasureUnitPlacement = GoalKeyResultMeasureUnitPlacement;

  @Input() keyResultForm!: UntypedFormGroup;
  @Output() keyResultFormChange = new EventEmitter<UntypedFormGroup>();
  @Input() submitted!: boolean;
  @Input() resultIndex!: number;
  @Input() mode!: GoalCreateFormMode;
  @Input() inputGoal!: Goal;
  @Input() templateValues!: Array<string>;
  @Output() cancelAddKeyResult = new EventEmitter();

  globals: Globals;
  eFeature = CompanyFeatures;

  minDateMoment: moment.Moment;
  disableUntilDate: IMyDate;

  constructor(globals: Globals) {
    this.globals = globals;

    this.minDateMoment = moment().startOf('day');
    this.disableUntilDate = this.toMyDate(this.minDateMoment.clone().subtract(1, 'day'));
  }

  ngOnInit() {
    this.keyResultForm.controls.type.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        if (this.keyResultForm.controls.type.value === GoalKeyResultType.BINARY) {
          this.keyResultForm.controls.measureStartValue.setValue(0);
          this.keyResultForm.controls.measureGoalValue.setValue(1);
        } else {
          this.keyResultForm.controls.measureStartValue.setValue(0);
          this.keyResultForm.controls.measureGoalValue.setValue(100);
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.unsubscribe();
  }

  cancel() {
    this.cancelAddKeyResult.emit(this.resultIndex);
  }

  isNumber(value: any) {
    const number = value;
    return !isNaN(number);
  }

  private toMyDate(value: moment.Moment): IMyDate {
    return {
      year: value.year(),
      month: value.month() + 1,
      day: value.date()
    };
  }
}
